const bulletdata = [
    {
        "id": "temp.",
        "ranges": [
            35,
            16,
            11,
            0,
            100
        ],
        "measures": [
            3
        ],
        "markers": [
            68
        ]
    },
    {
        "id": "power",
        "ranges": [
            1.082036239147832,
            0.15015808221964322,
            0.4712316186646053,
            0,
            2
        ],
        "measures": [
            1.3190969839317475,
            1.3379598035000453
        ],
        "markers": [
            1.6568071145735526
        ]
    },
    {
        "id": "volume",
        "ranges": [
            16,
            3,
            4,
            15,
            0,
            39,
            0,
            40
        ],
        "measures": [
            23
        ],
        "markers": [
            40
        ]
    },
    {
        "id": "cost",
        "ranges": [
            33899,
            221361,
            13879,
            0,
            500000
        ],
        "measures": [
            57894,
            104493
        ],
        "markers": [
            487513
        ]
    },
    {
        "id": "revenue",
        "ranges": [
            3,
            0,
            9,
            0,
            9
        ],
        "measures": [
            8
        ],
        "markers": [
            7.871666395818391,
            8.87317336405779
        ]
    }
]
export default bulletdata;